module.exports = __webpack_public_path__ + "static/media/Chicken7.a0172197.png";